"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends10 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _FieldName = _interopRequireDefault(require("./Fields/FieldName"));

var _Instructions = _interopRequireDefault(require("./Fields/Instructions"));

var _CompletedBy = _interopRequireDefault(require("./Fields/CompletedBy"));

var _Required = _interopRequireDefault(require("./Fields/Required"));

var _Opaque = _interopRequireDefault(require("./Fields/Opaque"));

var _QuestionTypes = _interopRequireDefault(require("./Fields/QuestionTypes"));

require("../../../css/CommonProperties.css");

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

var CommonProperties = function CommonProperties(_ref) {
  var _question$data;

  var question = _ref.question,
      setQuestion = _ref.setQuestion,
      textTypes = _ref.textTypes,
      numericTypes = _ref.numericTypes,
      checkboxTypes = _ref.checkboxTypes,
      signatureTypes = _ref.signatureTypes,
      errorMessages = _ref.errorMessages;

  var _useState = (0, _react.useState)({
    name: false,
    question_type: false
  }),
      focusActive = _useState[0],
      setFocusActive = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      fieldNameClicked = _useState2[0],
      setFieldNameClicked = _useState2[1];

  var handleChecked = function handleChecked(e) {
    var _e$target = e.target,
        name = _e$target.name,
        checked = _e$target.checked;

    if (name === 'opaque') {
      setQuestion((0, _extends10["default"])({}, question, {
        data: (0, _extends10["default"])({}, question.data, {
          opaque: checked
        })
      }));
    } else {
      var _extends2;

      setQuestion((0, _extends10["default"])({}, question, (_extends2 = {}, _extends2[name] = checked, _extends2)));
    }
  };

  var handleChange = function handleChange(e) {
    var _extends3, _extends4;

    switch (e.target.name) {
      case 'name':
        setFieldNameClicked(true);
        break;

      default:
        break;
    } // eslint-disable-next-line no-unused-expressions


    e.target.value ? setFocusActive((0, _extends10["default"])({}, focusActive, (_extends3 = {}, _extends3[e.target.name] = true, _extends3))) : setFocusActive((0, _extends10["default"])({}, focusActive, (_extends4 = {}, _extends4[e.target.name] = false, _extends4))); // Get the field value, ensuring it's a string for the name field

    var fieldValue = e.target.name === 'name' ? String(e.target.value) : e.target.value; // Check if we need to handle the update with special data preservation
    // This flag is set by FieldName component when clearing default names

    if (e.preserveData) {
      var _extends5;

      setQuestion((0, _extends10["default"])({}, question, (_extends5 = {}, _extends5[e.target.name] = fieldValue, _extends5)));
    } else {
      var _extends6; // Standard update with data property initialization if needed


      setQuestion((0, _extends10["default"])({}, question, (_extends6 = {}, _extends6[e.target.name] = fieldValue, _extends6.data = question.data || {
        pos: [],
        page: 1,
        character_spacing: '0',
        opaque: false,
        overflow: 'expand',
        size: '12'
      }, _extends6)));
    }
  };

  var handleType = function handleType(e) {
    var _extends7;

    setQuestion((0, _extends10["default"])({}, question, (_extends7 = {}, _extends7[e.target.name] = parseInt(e.target.value, 10), _extends7)));
  };

  var dualSided = window.pdfFormConfigObject.dual_sided;

  var handleFocus = function handleFocus(e) {
    var _extends8, _extends9; // eslint-disable-next-line no-unused-expressions


    e.target.value ? setFocusActive((0, _extends10["default"])({}, focusActive, (_extends8 = {}, _extends8[e.target.name] = true, _extends8))) : setFocusActive((0, _extends10["default"])({}, focusActive, (_extends9 = {}, _extends9[e.target.name] = false, _extends9)));
    e.target.placeholder = '';
  };

  var handleCompletedBy = function handleCompletedBy(e) {
    // Ensure we maintain the data structure and all field types
    setQuestion((0, _extends10["default"])({}, question, {
      filler: e.target.value,
      // Ensure name is still a string
      name: typeof question.name === 'string' ? question.name : String(question.name || ''),
      // Preserve data object
      data: question.data || {
        pos: [],
        page: 1,
        character_spacing: '0',
        opaque: false,
        overflow: 'expand',
        size: '12'
      }
    }));
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Nav.Item, null,
    /*#__PURE__*/
    _react["default"].createElement(_FieldName["default"], {
      name: question.name,
      handleChange: handleChange,
      handleFocus: handleFocus,
      focusActive: focusActive,
      errorMessages: errorMessages,
      fieldNameClicked: fieldNameClicked
    })),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Nav.Item, null,
    /*#__PURE__*/
    _react["default"].createElement(_Instructions["default"], {
      hint: question.hint,
      handleChange: handleChange,
      focusActive: focusActive,
      errorMessages: errorMessages
    })), dualSided &&
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Nav.Item, null,
    /*#__PURE__*/
    _react["default"].createElement(_CompletedBy["default"], {
      filler: question.filler,
      handleChange: handleCompletedBy
    })),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Nav.Item, null,
    /*#__PURE__*/
    _react["default"].createElement(_Required["default"], {
      required: question.required,
      handleChange: handleChecked
    })),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Nav.Item, null,
    /*#__PURE__*/
    _react["default"].createElement(_Opaque["default"], {
      opaque: (_question$data = question.data) === null || _question$data === void 0 ? void 0 : _question$data.opaque,
      handleChange: handleChecked
    })),
    /* we do NOT want to render the "types" select unless its a text field or signature */
    (textTypes.includes(question.question_type) || signatureTypes.includes(question.question_type)) &&
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Nav.Item, null,
    /*#__PURE__*/
    _react["default"].createElement(_QuestionTypes["default"], {
      questionType: question.question_type,
      handleChange: handleType,
      textTypes: textTypes,
      numericTypes: numericTypes,
      checkboxTypes: checkboxTypes,
      signatureTypes: signatureTypes
    })))
  );
};

CommonProperties.propTypes = process.env.NODE_ENV !== "production" ? {
  // eslint-disable-next-line react/forbid-prop-types
  question: _propTypes["default"].objectOf(_propTypes["default"].any).isRequired,
  setQuestion: _propTypes["default"].func.isRequired,
  textTypes: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  numericTypes: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  checkboxTypes: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  signatureTypes: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  errorMessages: _propTypes["default"].bool.isRequired
} : {};

var _default = exports["default"] = CommonProperties;